export function Scanlines() {
  return <div className="scanlines" />;
}
